import { KpiValue } from "./TeamEmployee";

interface ClientKpiValueFragment {
  totalValue: number;
  previousTotalValue?: number | null;
  percentageChange?: number | null;
}

interface ClientEdgeFragment {
  node: {
    id: string;
    name: string;
    externalReference?: string | null;
  };
  revenue?: ClientKpiValueFragment | null;
  margin?: ClientKpiValueFragment | null;
  profit?: ClientKpiValueFragment | null;
  assignedEmployeeName?: string | null;
  lastVisitDate?: string | null;
  meanDaysBetweenOrders?: number | null;
}

interface ClientTotalsFragment {
  revenue?: ClientKpiValueFragment | null;
  profit?: ClientKpiValueFragment | null;
}

export default class CustomerListItem {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly externalReference: string | null,
    public readonly revenue: KpiValue,
    public readonly margin: KpiValue,
    public readonly profit: KpiValue,
    public readonly assignedEmployeeName: string | null,
    public readonly lastVisitDate: string | null,
    public readonly meanDaysBetweenOrders: number | null,
  ) {}

  static fromEdge(edge: ClientEdgeFragment): CustomerListItem {
    return new CustomerListItem(
      edge.node.id,
      edge.node.name,
      edge.node.externalReference ?? null,
      new KpiValue(edge.revenue?.totalValue ?? 0, edge.revenue?.percentageChange ?? null),
      new KpiValue(edge.margin?.totalValue ?? 0, edge.margin?.percentageChange ?? null),
      new KpiValue(edge.profit?.totalValue ?? 0, edge.profit?.percentageChange ?? null),
      edge.assignedEmployeeName ?? null,
      edge.lastVisitDate ?? null,
      edge.meanDaysBetweenOrders ?? null,
    );
  }
}

export class CustomersTotals {
  constructor(
    public readonly revenue: KpiValue,
    public readonly profit: KpiValue,
  ) {}

  static fromTotals(totals: ClientTotalsFragment): CustomersTotals {
    return new CustomersTotals(
      new KpiValue(
        totals.revenue?.totalValue ?? 0,
        totals.revenue?.percentageChange ?? null,
        totals.revenue?.previousTotalValue ?? null,
      ),
      new KpiValue(
        totals.profit?.totalValue ?? 0,
        totals.profit?.percentageChange ?? null,
        totals.profit?.previousTotalValue ?? null,
      ),
    );
  }
}
